import {
  CreateAvaturnExportRequest,
  CreateAvaturnExportResponse,
  CreateNewAvaturnAvatarRequest,
  CreateNewAvaturnAvatarResponse,
  CreateNewAvaturnSessionRequest,
  CreateNewAvaturnSessionResponse,
  GetAvaturnUserIdResponse,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

// const AVATURN_BASE_URL = 'https://api.avaturn.me/api/v1';
// const BearerToken =
//   'fY-_Kx4XN0_UA0kUoRsAxUtBPzE3UFsXRI40THSMPRQHMc1HThkyHnXbI06pLBny-ueqjxp3hWPzoR8JgOVvwQ';

// const httpAvaturn = axios.create({
//   baseURL: AVATURN_BASE_URL,
//   headers: {
//     Authorization: `Bearer ${BearerToken}`,
//     'Content-Type': 'application/json',
//   },
// });

export const getAvaturnUserId = async () => {
  return fetcher(() => http.post<GetAvaturnUserIdResponse>('/avaturn-users'));
};

export const createNewAvaturnAvatar = async (
  request: CreateNewAvaturnAvatarRequest,
) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(request)) {
    formData.append(key, value);
  }
  return fetcher(() =>
    http.post<CreateNewAvaturnAvatarResponse>('/avaturn-avatars', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  );
};

// 안쓰는 API

export const createNewAvaturnSession = async (
  request: CreateNewAvaturnSessionRequest,
) => {
  return fetcher(() =>
    http.post<CreateNewAvaturnSessionResponse>('/avaturn-sessions', request),
  );
};

export const createAvaturnExport = async (
  request: CreateAvaturnExportRequest,
) => {
  return fetcher(() =>
    http.post<CreateAvaturnExportResponse>('/avaturn-exports', request),
  );
};
